import script from "./DeviceSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceSettingsView.vue?vue&type=style&index=0&id=bba6b700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba6b700"]])

export default __exports__